import React from 'react'
import { Helmet } from 'react-helmet'

type Props = {
    canonicalURL: string,
    keywords: string,
    seoDescription: string,
    title: string
}

const MetaComponent = (props: Props) => {
    const { canonicalURL, keywords, seoDescription, title } = props
    return (
        <Helmet>
            <meta property="og:title" content={title} />
            <meta property="og:description" content={seoDescription} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={seoDescription} />
            {canonicalURL === '/404' && (
                <meta name="robots" content="noindex, nofollow" />
            )}
            {seoDescription && (
                <meta name="description" content={seoDescription} />
            )}
            {keywords && <meta name="keywords" content={keywords} />}
            {title && <title>{title}</title>}
            {canonicalURL && <link rel="canonical" href={canonicalURL} />}
        </Helmet>
    )
}

export { MetaComponent }
